import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Nosotros somos <span className="purple">NAAN </span> .
            <br />
            NAAN Soluciones somos una empresa joven, con un equipo de colaboradores con 15 años de experiencia en la rama ContPAQi.
            Esto es un recurso valioso para las empresas que buscan mejorar sus procesos administrativos y contables, con consultores expertos y amigables que ofrecen una variedad de servicios como soporte, 
            consultoría, cursos y reportes especiales, que definitivamente están bien capacitados para ayudar a las medianas y pequeñas empresas a crecer. 
            <br />
            Constantemente se generan reformas en
            nuestros sistema fiscal a nivel nacional, el SAT
            se encuentra siempre en evolución, por lo que
            NAAN asume el compromiso con sus clientes de
            proveer las herramientas electrónicas necesarias,
            para mantenerse actualizados y evolucionando a
            la par de dichos cambios.
            <br />
            <br />
          </p>
          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
